import $ from 'jquery';
// ---------------------------------------------------------
// Custom Functions for Back-End
// ---------------------------------------------------------
$(document).ready(function() {
  // Contact page
  if ($('.formContact').length){
    localStorage.removeItem('check_contact_thank');
  }
  if ($('.formContactConfirm').length){
    if (localStorage.getItem('check_contact_thank') == 'true') {
      location.replace('/contact')
    }
  }
  $('.formContactConfirm').submit(function() {
    if (this.beenSubmitted) {
      return false;
    }else{
      this.beenSubmitted = true;
    }
    localStorage.setItem('check_contact_thank', 'true');
  });

});
